const TextGradientColors = () => {
    return ['#004d4b',
        '#007CF0',
        '#00008b',
        '#9932cc',
        '#057e7c',
        '#620372',
        '#2cbdf7',
        '#5d0dac',
        '#010864',
        '#004e92',
        '#6441A5',
        '#42106e']
}
export default TextGradientColors()